import { createBrowserRouter, Navigate } from 'react-router-dom';
import AdminApp from './App';
import AdminLayout from '@admin/layouts/AdminLayout';
import AdminProfileLayout from '@admin/layouts/AdminProfileLayout';
import { GroupAdminGuard } from '@admin/components/guards/GroupAdminGuard';
import AdminProfilePage from '@admin/pages/admin-profile';
import AdminProfileEditPage from '@admin/pages/admin-profile/edit';
import UserSubscriptionListPage from '@admin/pages/user-subscriptions';
import UserManagementPage from '@admin/pages/user-management';
import PlanManagementPage from '@admin/pages/plan-management';
import LoginPage from '@admin/pages/login';
import NotFoundPage from '@admin/pages/not-found';
import { ForgotPasswordPage, ConfirmPasswordPage } from '@admin/pages/forgot-password';
import UsageGuidePage from '@user/pages/usage-guide';
import PrivacyPolicyPage from '@user/pages/privacy-policy';
import TermsOfServicePage from '@user/pages/terms-of-service';
import UserDetailPage from '@admin/pages/user-detail';
import { ROUTES, ADMIN_ROUTES, SCREEN_TYPE } from '@/shared/configs/constants';
import { VerifyEmailChangePage } from '../user/pages';
import withAuthenticationNotPermitted from '@/shared/hooks/withAuthenticationNotPermitted';
import NoAutht from '@/shared/layouts/NoAutht';
import LoginSSOPage from './pages/login-sso';
const AuthenticationNotPermitted = withAuthenticationNotPermitted(NoAutht);

export const adminRouter = createBrowserRouter([
    {
        path: '/',
        element: <AdminApp />,
        children: [
            {
                index: true,
                element: <Navigate to={ADMIN_ROUTES.userManagement.href} replace />
            },
            {
                path: ADMIN_ROUTES.login.href,
                element: <LoginPage />
            },
            {
                path: ADMIN_ROUTES.forgotPassword.href,
                element: <ForgotPasswordPage />
            },
            {
                path: '/',
                element: <AuthenticationNotPermitted screenType={SCREEN_TYPE.GA} />,
                children: [
                    {
                        path: ADMIN_ROUTES.confirmPassword.href,
                        element: <ConfirmPasswordPage />
                    },
                    {
                        path: ADMIN_ROUTES.verifyEmailChange.href,
                        element: <VerifyEmailChangePage />
                    }
                ]
            },
            {
                element: <GroupAdminGuard />,
                children: [
                    {
                        element: <AdminLayout />,
                        children: [
                            {
                                path: ADMIN_ROUTES.userSubscriptions.href,
                                element: <UserSubscriptionListPage />
                            },
                            {
                                path: ADMIN_ROUTES.userManagement.href,
                                element: <UserManagementPage />
                            },
                            {
                                path: `${ADMIN_ROUTES.userManagement.href}/:id`,
                                element: <UserDetailPage />
                            },
                            {
                                path: ADMIN_ROUTES.planManagement.href,
                                element: <PlanManagementPage />
                            }
                        ]
                    },
                    {
                        element: <AdminProfileLayout />,
                        children: [
                            {
                                path: ADMIN_ROUTES.profile.href,
                                element: <AdminProfilePage />
                            },
                            {
                                path: ADMIN_ROUTES.profileEdit.href,
                                element: <AdminProfileEditPage />
                            }
                        ]
                    }

                ]
            },
            {
                path: ROUTES.loginSSO.href,
                element: <LoginSSOPage />
            },
            {
                element: <AdminLayout />,
                children: [
                    {
                        path: ROUTES.usageGuide.href,
                        element: <UsageGuidePage />
                    },
                    {
                        path: ROUTES.privacyPolicy.href,
                        element: <PrivacyPolicyPage />
                    },
                    {
                        path: ROUTES.termsOfService.href,
                        element: <TermsOfServicePage />
                    }
                ]
            },
            {
                path: '*',
                element: <NotFoundPage />
            }
        ]
    }
]);
